import { IOTGVideoData } from 'redhotpie-shared-lib/interfaces/INewFeed';
import * as utils from '../functions/utils';
import { IContentItemVideo } from 'redhotpie-shared-lib/interfaces/ICommunity';

export default class OTGVideo {
  id: number;
  parrentType: string;
  title: string;
  description: string;
  likeCount: number;
  replyCount: number;
  isMemberLike: boolean;
  siteVideoType: string;
  videoCode: string;
  videoType: string;
  classification: number;
  imgUrl: string;
  videoUrl: string;
  seoURL?: string;

  constructor() {
    this.id = -1;
    this.parrentType = '';
    this.title = '';
    this.description = '';
    this.likeCount = 0;
    this.replyCount = 0;
    this.isMemberLike = false;
    this.siteVideoType = '';
    this.videoCode = '';
    this.videoType = '';
    this.classification = 0;
    this.imgUrl = '';
    this.videoUrl = '';
    this.seoURL = '';
  }

  static mappingObject(_obj: IOTGVideoData): IContentItemVideo {
    let obj = Object.assign(new OTGVideo(), _obj);
    obj.id = _obj.ID ? _obj.ID : -1;
    obj.title = _obj.Title ? _obj.Title : '';
    obj.description = _obj?.Description || '';
    obj.likeCount = _obj.LikeCount || 0;
    obj.replyCount = _obj.ReplyCount || 0;
    obj.isMemberLike = _obj.IsMemberLike ? _obj.IsMemberLike : false;
    obj.siteVideoType = _obj.SiteVideoType ? _obj.SiteVideoType : '';
    obj.videoCode = _obj.VideoCode ? _obj.VideoCode : '';
    obj.videoType = _obj.VideoType ? _obj.VideoType : '';
    obj.classification = _obj.Classification ? _obj.Classification : 0;
    obj.imgUrl = _obj.ImgUrl ? _obj.ImgUrl : '';
    obj.videoUrl = _obj.OTGVideoUrl || '';
    obj.seoURL = _obj.SEOUrl || '';
    obj = utils.cleanObjectKeys(Object.keys(new OTGVideo()), obj);
    return obj;
  }

  static mappingObjects(_data: IOTGVideoData[]): IContentItemVideo[] {
    return _data.map(item => OTGVideo.mappingObject(item));
  }
}
